import { render, staticRenderFns } from "./LmTableCustom.vue?vue&type=template&id=afac52fc&scoped=true&"
import script from "./LmTableCustom.vue?vue&type=script&lang=js&"
export * from "./LmTableCustom.vue?vue&type=script&lang=js&"
import style0 from "./LmTableCustom.vue?vue&type=style&index=0&id=afac52fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afac52fc",
  null
  
)

export default component.exports